import { Moment } from 'moment-mini'
import { Resource } from 'src/app/shared/interfaces'

export enum MessageType {
  PUSH_MESSAGE = 0,
  PUSH_MESSAGE_READ_REQUEST = 1,
  MESSAGE = 2
}

export class Message extends Resource {
  id: number
  senderPersonId: number
  recipientPersonId: number
  recipientGroup: string
  message: string
  messageType: MessageType
  datePosted: Moment
  dateRead: Moment
  pushed: boolean
  serieProposalId: number
}
